import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import _ from 'lodash';
import { ToastContainer, toast as setToast, Zoom } from 'react-toastify';

import { Button } from 'components'
import { FaTimes, FaExclamationTriangle } from 'react-icons/fa'
import * as actionCreators from 'store/actions'

const CustomToastContainer = styled(ToastContainer).attrs({
    // custom props
})`
    .Toastify__toast-container {
        font-family: 'Helvetica', 'Arial', sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }
    .Toastify__toast {
        background-color: ${props => props.backgroundColor || 'var(--secondary-color)'};
        box-shadow: ${props => props.color 
                ? "0px 2px 1px -1px " + props.color + 
                ", 0px 1px 1px 0px " + props.color +
                ", 0px 1px 3px 0px " + props.color
                : "0px 2px 1px -1px var(--primary-accent2-color)," + 
                "0px 1px 1px 0px var(--primary-accent2-color), " +
                "0px 1px 3px 0px var(--primary-accent2-color)"};
    }
    .Toastify__toast--error {}
    .Toastify__toast--warning {}
    .Toastify__toast--success {}
    .Toastify__toast-body {
        color: var(--text-color);
        /* font-size: 16px; */
    }
    .Toastify__progress-bar {}
`;

const Container = styled.div`
    display: grid;
    grid-template-columns: 0.1rem 1fr;
    grid-template-rows: 1rem 2rem;
    column-gap: 0.75rem;
`

const Title = styled.div`
    font-size: 0.9rem;
    font-weight: bolder;
    align-self: end;
`

const Subtitle = styled.div`
    font-size: 0.8rem;
    align-self: start;
`

const Indicator = styled.div`
    height: 100%;
    width: 0.1rem;
    border-radius: 5px;
    background-color: var(--error-color);
    grid-row: 1/ span 2;
    grid-column: 1/ span 1;
    justify-self: center;
    align-self: center;
    color: var(--error-color);
`

const Icon = styled.div`
    grid-column: 2/ span 1;
    grid-row: 1/ span 2;
    justify-self: center;
    align-self: center;
    color: var(--error-color);
    font-size: 1.2rem;
`

class Toaster extends Component {

    render () {
        this.props.error && setToast(
            <Container onClick={() => {window.location.reload(false)}}>
                <Indicator/>
                {/* <Icon><FaExclamationTriangle/></Icon> */}
                <Title>{this.props.error}</Title>
                <Subtitle>{this.props.errorSubtitle || 'Sorry! There was an error with your last request. Click to reload.'}</Subtitle>
            </Container>
        ,{containerId: 'second'})
        const closeButton = <Button icon={<FaTimes/>} iconOnly styles={{backgroundColor: 'var(--secondary-color)', margin: 0, padding: '0rem'}} onSelect={() => {window.location.reload(false)}}/>
        return (
            <CustomToastContainer closeButton={false}
                containerId='second' transition={Zoom} enableMultiContainer={true}
                position="top-center"
                autoClose={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover/>
        )
    }
}

const mapStateToProps = state => {
    return {
        error: state.db.present.error,
    }
};

const mapDispatchToProps = dispatch => {
    return {
        setError: (error) => dispatch(actionCreators.setError(error))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Toaster);
